import { sessionCache } from '@services/cache';
import getCartId from './getCartId';
import getCartIsPlusDiscountApplied from './getCartIsPlusDiscountApplied';

const getCartPlusInfo = state => {
  const isDiscountAlreadyApplied = getCartIsPlusDiscountApplied(state);
  if (isDiscountAlreadyApplied) return null;
  const guid = getCartId(state);
  return sessionCache.get(`cart_plus_${guid}`) || null;
};

export default getCartPlusInfo;
